import Swal from "sweetalert2";
import "../styles/common/swalTheme.css";

const BASE_CLASSES = {
  popup: "app-swal-popup",
  title: "app-swal-title",
  htmlContainer: "app-swal-text",
  confirmButton: "app-swal-confirm",
  cancelButton: "app-swal-cancel",
};

const BASE_OPTIONS = {
  buttonsStyling: false,
  reverseButtons: true,
  width: 320,
};

export function swalSuccess({
  title = "انجام شد",
  text = "",
  confirmText = "متوجه شدم",
} = {}) {
  return Swal.fire({
    ...BASE_OPTIONS,
    icon: "success",
    title,
    text,
    confirmButtonText: confirmText,
    customClass: {
      ...BASE_CLASSES,
      icon: "app-swal-icon app-swal-icon-success",
    },
  });
}

export function swalError({
  title = "خطا",
  text = "خطایی در انجام عملیات رخ داد.",
  confirmText = "باشه",
} = {}) {
  return Swal.fire({
    ...BASE_OPTIONS,
    icon: "error",
    title,
    text,
    confirmButtonText: confirmText,
    customClass: {
      ...BASE_CLASSES,
      confirmButton: "app-swal-confirm app-swal-confirm-danger",
      icon: "app-swal-icon app-swal-icon-danger",
    },
  });
}

export function swalWarning({
  title = "توجه",
  text = "",
  confirmText = "باشه",
} = {}) {
  return Swal.fire({
    ...BASE_OPTIONS,
    icon: "warning",
    title,
    text,
    confirmButtonText: confirmText,
    customClass: {
      ...BASE_CLASSES,
      icon: "app-swal-icon app-swal-icon-warning",
    },
  });
}

/**
 * دیالوگ تأیید (مثلاً پیش از حذف).
 * پاسخ Promise<boolean> برمی‌گردونه: true یعنی کاربر تأیید کرد.
 */
export async function swalConfirm({
  title = "مطمئنی؟",
  text = "",
  confirmText = "بله",
  cancelText = "انصراف",
  danger = false,
} = {}) {
  const result = await Swal.fire({
    ...BASE_OPTIONS,
    icon: "warning",
    title,
    text,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    customClass: {
      ...BASE_CLASSES,
      confirmButton: danger
        ? "app-swal-confirm app-swal-confirm-danger"
        : "app-swal-confirm",
      icon: "app-swal-icon app-swal-icon-warning",
    },
  });
  return result.isConfirmed;
}

export async function swalReject({
  title = "رد درخواست",
  label = "دلیل رد",
  placeholder = "دلیل رد را وارد کنید...",
  confirmText = "ثبت رد",
  cancelText = "انصراف",
} = {}) {
  const result = await Swal.fire({
    ...BASE_OPTIONS,

    title,

    input: "textarea",
    inputLabel: label,
    inputPlaceholder: placeholder,

    inputAttributes: {
      dir: "rtl",
    },

    showCancelButton: true,

    confirmButtonText: confirmText,
    cancelButtonText: cancelText,

    customClass: {
      ...BASE_CLASSES,
      confirmButton: "app-swal-confirm app-swal-confirm-danger",
      cancelButton: "app-swal-cancel",
      input: "app-swal-input",
    },

    didOpen: () => {
      const confirmBtn = Swal.getConfirmButton();
      const textarea = Swal.getInput();

      confirmBtn.disabled = true;

      textarea.addEventListener("input", () => {
        confirmBtn.disabled = textarea.value.trim() === "";
      });
    },
  });

  return {
    note: result.value?.trim() || "",
    isConfirmed: result.isConfirmed,
  };
}
